import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts'

const COLORS = ['#57a6d8', '#2fbc80', '#8d82bc', '#eb6587', '#f6c23e']

interface DispositivosChartProps {
  datos: { dispositivo: string; count: number }[]
}

export function DispositivosChart({ datos }: DispositivosChartProps) {
  const chartData = datos.map((d) => ({ name: d.dispositivo, value: d.count }))

  return (
    <Card className="border border-gray-300 dark:border-gray-700">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Dispositivos</CardTitle>
      </CardHeader>
      <CardContent>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={90}
                dataKey="value"
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {chartData.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-sm text-muted-foreground">Sin datos</p>
        )}
      </CardContent>
    </Card>
  )
}
